import { createApiClient } from "@jbnl/api-client";

export const api = createApiClient();
